import React  from 'react';

import xudinglaodonghetong1 from '../assets/img/xudinglaodonghetong1.png';
import xudinglaodonghetong2 from '../assets/img/xudinglaodonghetong2.png';

const Enclosure313 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div>
            <img src={xudinglaodonghetong1} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={xudinglaodonghetong2} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            
            <br/><br/>
        </div>
    </div>



export default Enclosure313;